import { render, staticRenderFns } from "./TaskInfo.vue?vue&type=template&id=612f2eea&scoped=true"
import script from "./TaskInfo.vue?vue&type=script&lang=js"
export * from "./TaskInfo.vue?vue&type=script&lang=js"
import style0 from "./TaskInfo.vue?vue&type=style&index=0&id=612f2eea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612f2eea",
  null
  
)

export default component.exports